module.exports = __webpack_public_path__ + "static/media/space-station-moon-alt.393da0d5.svg";